import React from 'react';
import { StatusChangeApproval } from './StatusChangeApproval';
import { RateLimitApproval } from './RateLimitApproval';
import { ToolCall } from '../../hooks/useWorkflowChat';

interface ApprovalDialogsProps {
  pendingApproval?: ToolCall | null;
  pendingNodeName?: string;
  rateLimitApproval?: {
    allowedCount: number;
    blockedToolCalls: ToolCall[];
    resourceType: string;
  } | null;
  onToolApproval: () => void;
  onToolRejection: () => void;
  onRateLimitApproval: (allow: boolean) => void;
}

/**
 * Component for rendering approval dialogs (status change and rate limit)
 */
export function ApprovalDialogs({
  pendingApproval,
  pendingNodeName,
  rateLimitApproval,
  onToolApproval,
  onToolRejection,
  onRateLimitApproval,
}: ApprovalDialogsProps) {
  return (
    <>
      {/* Pending approval UI */}
      {pendingApproval && (
        <StatusChangeApproval
          toolCall={pendingApproval}
          nodeName={pendingNodeName}
          onApprove={onToolApproval}
          onReject={onToolRejection}
        />
      )}
      {/* Rate limit approval UI */}
      {rateLimitApproval && (
        <RateLimitApproval
          allowedCount={rateLimitApproval.allowedCount}
          blockedToolCalls={rateLimitApproval.blockedToolCalls}
          resourceType={rateLimitApproval.resourceType as "node" | "edge"}
          onAllow={() => onRateLimitApproval(true)}
          onSkip={() => onRateLimitApproval(false)}
        />
      )}
    </>
  );
}
